import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Row,
} from 'reactstrap';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../../common/resource/proptypes/CommonPropTypes';
import {
  COMPANY_STAFF_TYPE,
  DEFAULT_PAGE_SIZE,
  ITINERARY_TYPE,
  ITINERARY_TYPE_CONTRACT,
  TICKET_STATUS,
  TRIP_CIRCUIT_STATUS,
} from '../../../../../config/constants';
import {
  ITINERARY_CREATED_FROM_API_WARNING_MESSAGE,
  ITINERARY_SCHEDULE_WITHOUT_SEGMENT_LIST_MESSAGE,
  ITINERARY_WITHOUT_CABIN_CREW_INFO_MESSAGE,
  ITINERARY_WITHOUT_DRIVER_INFO_MESSAGE,
  ITINERARY_WITHOUT_PASSENGER_FLOW_MESSAGE,
  PENDING_SCHEDULING_WARNING_MESSAGE,
} from '../../../../../config/messages';
import {
  CIRCUIT_PATH,
  CUSTOMER_PATH,
  ITINERARY_PATH,
  ITINERARY_SCHEDULE_PATH,
  OLD_FRONT_SEAT_MAP_PATH,
  PRICING_PROFILE_PATH,
  ROUTE_PATH,
} from '../../../../../config/paths';
import {
  clearDrivers,
  clearItinerary,
  clearItineraryHistory,
  clearItinerarySeatMap,
  clearPassengerFlowForItinerary,
  clearPersonnelForItinerary,
  getItineraryHistory,
  getItinerarySchedule,
  getItineraryV2,
  getItinerarySeatMap,
  getListDriversForItinerary,
  getPassengerFlowForItinerary,
  getPersonnelForItinerary,
  postVerifyCustomer,
  putBoardPassenger,
  getItineraryGeofenceAlerts,
  clearItineraryGeofenceAlerts,
} from '../../../../../actions';
import { tzNormalizeDate } from '../../../../../utils/date';
import {
  ITINERARY_FLOOR_VARIATION_HISTORY_COLUMNS,
  generatePersonnelColumns,
} from '../../../../../config/columns';
import {
  DATE_TIME_FORMAT,
  FULL_DATE_TIME_FORMAT,
} from '../../../../../config/locale';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import Modal from '../../../../common/modal/Modal';
import Table from '../../../../common/Table';
import Alert from '../../../../common/informative/Alert';
import Loader from '../../../../common/Loader';
import Content from '../../../../layout/Content';
import Checkbox from '../../../../common/forms/Checkbox';
import IsActive from '../../../../common/cells/IsActive';
import BadgeList from '../../../../common/BadgeList';
import ItineraryToolbar from './ItineraryToolbar';
import NoDataResource from '../../../../common/resource/NoDataResource';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import TimetableTemplate from '../TimetableTemplate';
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource';
import ItineraryPassengerFlowForm from './ItineraryPassengerFlowForm';
import CollapsibleHeader from '../../../../layout/CollapsibleHeader';
import SeatSelectionHeader from '../../../../modules/booking/seats/SeatSelectionHeader';
import SeatMap from '../../../../modules/booking/seats/SeatMap';
import VoidTicketButton from '../../../reservation/ticket/ticket-toolbar/VoidTicketButton';
import ItineraryHistoryAlerts from './ItineraryHistoryAlerts';
import ItineraryGeofenceAlerts from './ItineraryGeofenceAlerts';
import {
  clearItineraryClosure,
  getItineraryClosure,
} from '../../../../../actions/itinerary/ItineraryClosure';
import { numberFormatter } from '../../../../../utils/number';
import ItineraryTicketTable from '../itinerary-for-counter/ItineraryTicketTable';

export const Itinerary = ({
  breadcrumbs,
  itinerary,
  loading,
  personnelLoading,
  passengerFlow,
  drivers,
  isForMine,
  personnel,
  dispatchClearPersonnelForItinerary,
  dispatchGetPersonnelForItinerary,
  dispatchClearItinerary,
  dispatchClearPassengerFlowForItinerary,
  dispatchClearDrivers,
  dispatchGetItinerary,
  dispatchGetPassengerFlowForItinerary,
  dispatchGetListDriversForItinerary,
  dispatchPostVerifyCustomer,
  dispatchPutBoardPassenger,
  dispatchClearItinerarySeatMap,
  sourceItinerary,
  dispatchGetItinerarySeatMap,
  loadingSourceItinerary,
  match: {
    params: { id: itineraryId },
  },
  history,
  dispatchGetItineraryHistory,
  dispatchClearItineraryHistory,
  passengerListSourceItinerary,
  geofenceAlerts,
  dispatchGetItineraryGeofenceAlerts,
  dispatchClearItineraryGeofenceAlerts,
  dispatchGetItineraryClosure,
  dispatchClearItineraryClosure,
  itineraryClosure,
}) => {
  useLayoutEffect(() => {
    dispatchGetItinerary({ itineraryId });
    dispatchGetItineraryHistory({ itineraryId });
    dispatchGetListDriversForItinerary({ itineraryId });
    dispatchGetPassengerFlowForItinerary({ itineraryId });
    dispatchGetItineraryGeofenceAlerts(itineraryId);
    dispatchGetItineraryClosure({ itineraryId });
    if (isForMine) {
      dispatchGetItinerarySeatMap({ itineraryId, type: 'source' });
      dispatchGetPersonnelForItinerary({ itineraryId });
    }
    return () => {
      dispatchClearItinerary();
      dispatchClearPassengerFlowForItinerary();
      dispatchClearDrivers();
      dispatchClearPersonnelForItinerary();
      dispatchClearItineraryHistory();
      dispatchClearItinerarySeatMap({ type: 'source' });
      dispatchClearItineraryGeofenceAlerts();
      dispatchClearItineraryClosure();
    };
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState(null);

  const onSubmitPassengerFlow = (formValues) => {
    dispatchPutBoardPassenger({ ...formValues, itineraryId });
  };

  const renderPassengerFlowModal = (type, currentPassengerFlow, index) => {
    const isBoarding = type === 'boarding';
    const title = `${isBoarding ? 'Embarque' : 'Desembarque'}: ${
      currentPassengerFlow.locationName
    } (${currentPassengerFlow[`${type}Passengers`]})`;

    const body = (
      <ItineraryPassengerFlowForm
        onSubmit={onSubmitPassengerFlow}
        type={type}
        index={index}
      />
    );

    setShowModal(true);
    setModalTitle(title);
    setModalBody(body);
  };

  const renderSeatMap = (title, data, loadingSeatMap) => {
    if (loadingSeatMap) return <Loader />;
    if (data.isEmpty()) return null;

    const destinationLocationId = data.get('destination').id;
    const sourceLocationId = data.get('origin').id;
    const seatMapItineraryId = data.get('itinerary').id;
    const { floors } = data.get('seatMapDTO');
    const seatReservations = Immutable.Set();
    const seatSelectionChangesInProgress = Immutable.Set();
    const numPassengers = data.get('availableSeats');

    const itinerarySearchResult = {
      seatMapDisplayName: data.get('seatMapDisplayName'),
      arrivalTime: data.get('arrivalTime'),
      departureTime: data.get('departureTime'),
      origin: data.get('origin'),
      destination: data.get('destination'),
    };

    return (
      <div>
        <Card>
          <CardBody>
            <CardTitle tag="h4" className="text-center">
              {title}
            </CardTitle>
            <CardSubtitle>
              <SeatSelectionHeader
                itinerarySearchResult={itinerarySearchResult}
              />
            </CardSubtitle>
          </CardBody>
          <CardBody>
            <SeatMap
              destinationLocationId={destinationLocationId}
              sourceLocationId={sourceLocationId}
              itineraryId={seatMapItineraryId}
              floors={floors}
              handleSeatSelection={() => {}}
              handleSeatDeselection={() => {}}
              seatReservations={seatReservations}
              seatSelectionChangesInProgress={seatSelectionChangesInProgress}
              numPassengers={numPassengers}
            />
          </CardBody>
        </Card>
      </div>
    );
  };

  const renderPassengerTable = (title, data, loadingPassengerTable) => {
    if (loadingPassengerTable) return <Loader />;
    if (data.isEmpty()) return null;
    const passengers = data.toJS();
    return (
      <div>
        <h4 className="text-center">{title}</h4>
        <Table
          columns={[
            {
              Header: 'Asiento',
              accessor: 'seatNumber',
              className: 'text-center',
              width: 120,
            },
            {
              Header: 'Pasajero',
              accessor: 'customer.fullName',
              className: 'text-center',
            },
            {
              Header: '',
              className: 'text-center',
              notNavigateToModel: true,
              Cell: (row) =>
                row.original.ticketStatus === TICKET_STATUS.ACTIVE.value && (
                  <VoidTicketButton
                    ticketId={row.original.ticketId}
                    email={row.original.customer.email}
                    className="p-1"
                    afterVoidTicket={() => {
                      dispatchGetPersonnelForItinerary({ itineraryId });
                      dispatchGetItinerarySeatMap({
                        itineraryId,
                        type: 'source',
                      });
                    }}
                  />
                ),
              filterable: false,
            },
          ]}
          data={passengers}
          defaultPageSize={
            passengers.length <= 10 ? passengers.length : DEFAULT_PAGE_SIZE
          }
          showPagination={passengers.length > 10}
        />
      </div>
    );
  };

  const renderPassengersFlow = (type, currentPassengerFlow, index) => {
    let passengers = 0;

    if (currentPassengerFlow[`${type}Passengers`]) {
      passengers = (
        <div
          role="button"
          onClick={() =>
            renderPassengerFlowModal(type, currentPassengerFlow, index)
          }
          onKeyPress={() =>
            renderPassengerFlowModal(type, currentPassengerFlow, index)
          }
          tabIndex="0"
          className="clickable"
        >
          <strong>
            <u>{currentPassengerFlow[`${type}Passengers`]}</u>
          </strong>
        </div>
      );
    }
    return passengers;
  };

  const renderHistory = (existsTrip) => {
    if (
      !history ||
      history.isEmpty() ||
      history.get('itineraryHistoryList', []).length === 0
    ) {
      return null;
    }

    const historyJson = history.toJS();
    return (
      <>
        {historyJson.itineraryHistoryList
          .slice(existsTrip ? 1 : 0)
          .map(
            ({
              id,
              registeredBus,
              itineraryHistoryDriverList,
              assigmentDate,
            }) => (
              <div key={id}>
                <Row>
                  <Col>
                    <h4>Bus</h4>
                    <ResourceProperty label="Número de bus:">
                      {registeredBus ? registeredBus.companyBusId : '-'}
                    </ResourceProperty>
                    <ResourceProperty label="Mapa de Asientos:">
                      {registeredBus ? registeredBus.seatMapName : '-'}
                    </ResourceProperty>
                    <ResourceProperty label="Matrícula:">
                      {registeredBus ? registeredBus.licensePlate : '-'}
                    </ResourceProperty>
                    <ResourceProperty label="Fecha de asignación:">
                      {tzNormalizeDate({
                        date: assigmentDate,
                        format: DATE_TIME_FORMAT,
                      })}
                    </ResourceProperty>
                  </Col>
                  <Col>
                    <h4>Conductores</h4>
                    {itineraryHistoryDriverList.length === 0 ? (
                      <Alert type="warning" message="No hay conductores" />
                    ) : (
                      <Table
                        columns={[
                          {
                            Header: 'Nombre',
                            accessor: 'driverFullName',
                            className: 'text-center',
                          },
                          {
                            Header: 'Documento',
                            Cell: (row) =>
                              `${row.original.driverIdentificationTypeName} - ${row.original.driverIdentificationNumber}`,
                            className: 'text-center',
                          },
                        ]}
                        data={itineraryHistoryDriverList}
                        defaultPageSize={itineraryHistoryDriverList.length}
                        showPagination={false}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            ),
          )}
      </>
    );
  };

  const renderFloorVariationHistory = () => {
    if (
      !history ||
      history.isEmpty() ||
      history.get('itineraryFloorVariationHistoryList', []).length === 0
    ) {
      return null;
    }

    const historyJson = history.toJS();
    return (
      <>
        <Table
          columns={ITINERARY_FLOOR_VARIATION_HISTORY_COLUMNS}
          data={historyJson.itineraryFloorVariationHistoryList}
          defaultPageSize={
            historyJson.itineraryFloorVariationHistoryList.length
          }
          showPagination={false}
        />
      </>
    );
  };

  const renderChangeTripObservation = () => {
    if (itinerary.get('changeTripReasonList', []).length === 0) {
      return null;
    }

    return (
      <>
        {itinerary
          .get('changeTripReasonList', [])
          .map(({ id, observation, userCustomerFullName }) => (
            <div key={id}>
              <Row>
                <Col>
                  <h4>Usuario</h4>
                  <ResourceProperty label="Nombre:">
                    {userCustomerFullName || '-'}
                  </ResourceProperty>
                </Col>
                <Col>
                  <h4>Observacion</h4>
                  <p>{observation}</p>
                </Col>
              </Row>
            </div>
          ))}
      </>
    );
  };

  const renderItineraryClosure = () => {
    if (!itineraryClosure || itineraryClosure.isEmpty()) {
      return null;
    }

    const itineraryClosureJson = itineraryClosure.toJS();
    return (
      <>
        <hr />
        <h3>Cierre de Itinerario</h3>
        <p>
          <strong>Motivo de cierre:</strong>{' '}
          {itineraryClosureJson.closureReason
            ? itineraryClosureJson.closureReason.reasonName
            : '-'}
        </p>

        <p>
          <strong>Monto total vendido al cierre:</strong>{' '}
          {numberFormatter({
            value: itineraryClosureJson.totalSalesAfterClosure,
          })}
        </p>

        <p>
          <strong>Fecha de creación:</strong>{' '}
          {tzNormalizeDate({
            date: itineraryClosureJson.createDate,
            format: DATE_TIME_FORMAT,
          })}
        </p>

        <p>
          <strong>Fecha de actualización:</strong>{' '}
          {tzNormalizeDate({
            date: itineraryClosureJson.lastUpdate,
            format: DATE_TIME_FORMAT,
          })}
        </p>
      </>
    );
  };

  const verifyCustomer = ({ type, id: customerId }) => {
    dispatchPostVerifyCustomer({ itineraryId, customerId, type });
  };

  let content;
  let toolbar;

  if (loading) {
    content = <Loader />;
  } else if (itinerary.isEmpty()) {
    content = <NoDataResource returnPage={ITINERARY_PATH} />;
  } else {
    const {
      createdFromApi,
      itineraryScheduleId,
      followsTemplate,
      isMaciva,
      firstFloorPriceVariation,
      secondFloorPriceVariation,
      type,
      company,
      itineraryCorrelationId,
      route,
      circuit,
      serviceType,
      active,
      seatMap,
      driverCommission,
      cabinCrewCommission,
      departureTime,
      trip,
      id,
      companyItineraryAditionalFields,
    } = itinerary.toJS();

    let createdFromApiMessageAlert = null;

    if (createdFromApi) {
      createdFromApiMessageAlert = (
        <Alert
          type="warning"
          message={ITINERARY_CREATED_FROM_API_WARNING_MESSAGE}
        />
      );
    }

    let templateAlert = null;

    if (itineraryScheduleId && !isForMine) {
      const link = (
        <Link
          to={`${ITINERARY_SCHEDULE_PATH}/${itinerary.get(
            'itineraryScheduleId',
          )}`}
        >
          esta plantilla
        </Link>
      );

      let infoMessageOfFollowsATemplate = (
        <span>Este itinerario esta asociado con {link}, pero no la sigue</span>
      );

      if (followsTemplate) {
        infoMessageOfFollowsATemplate = (
          <span>Este itinerario sigue {link}</span>
        );
      }

      templateAlert = (
        <Alert type="info" message={infoMessageOfFollowsATemplate} />
      );
    }

    const firstFloorPriceVariationContent =
      firstFloorPriceVariation !== 0 ? (
        <ResourceProperty label="Variación de Precio del Primer Piso:">
          {firstFloorPriceVariation || '-'}
        </ResourceProperty>
      ) : null;

    const secondFloorPriceVariationContent =
      secondFloorPriceVariation !== 0 ? (
        <ResourceProperty label="Variación de Precio del Segundo Piso:">
          {secondFloorPriceVariation || '-'}
        </ResourceProperty>
      ) : null;

    let companyResource = null;

    if (type === ITINERARY_TYPE_CONTRACT) {
      companyResource = (
        <ResourceProperty label="Compañia Contrato:">
          {company ? company.name : '-'}
        </ResourceProperty>
      );
    }

    let basicInformationResource = (
      <>
        <h3>Información Básica</h3>
        <ResourceProperty label="ID de Correlación Civa:">
          {itineraryCorrelationId || '-'}
        </ResourceProperty>
        <ResourceProperty label="Ruta:">
          <LinkToModuleResource
            text={`${route.id} - ${route.name}`}
            href={`${ROUTE_PATH}/${route.id}`}
            isExternalPath
          />
        </ResourceProperty>
        <ResourceProperty label="Circuito:">
          <LinkToModuleResource
            text={`${circuit.id} - ${circuit.name}`}
            href={`${CIRCUIT_PATH}/${circuit.id}`}
            isExternalPath
          />
        </ResourceProperty>
        <ResourceProperty label="Tipo de Servicio:">
          {serviceType ? serviceType.name : '-'}
        </ResourceProperty>
        <ResourceProperty label="Maciva:">
          <Checkbox checked={isMaciva} />
        </ResourceProperty>
        <ResourceProperty label="Estado:">
          <IsActive value={active} />
        </ResourceProperty>
        <ResourceProperty label="Mapa de Asientos:">
          {seatMap && seatMap.id ? (
            <LinkToModuleResource
              text={`${seatMap.id} - ${seatMap.name}`}
              href={`${OLD_FRONT_SEAT_MAP_PATH}/${seatMap.id}`}
              isExternalPath
            />
          ) : (
            '-'
          )}
        </ResourceProperty>
        <ResourceProperty label="Perfil de Precio:">
          <BadgeList
            textArray={itinerary
              .get('itineraryPricingProfiles')
              .map((pricingProfile) => ({
                text: `${pricingProfile.id} - ${pricingProfile.name}`,
                href: `${PRICING_PROFILE_PATH}/${pricingProfile.id}`,
              }))}
          />
        </ResourceProperty>
        {firstFloorPriceVariationContent}
        {secondFloorPriceVariationContent}
        <ResourceProperty label="Comisión del Conductor:">
          {driverCommission && driverCommission.id
            ? `${driverCommission.id} - ${driverCommission.name}`
            : '-'}
        </ResourceProperty>
        <ResourceProperty label="Comisión del Servicio a Bordo:">
          {cabinCrewCommission && cabinCrewCommission.id
            ? `${cabinCrewCommission.id} - ${cabinCrewCommission.name}`
            : '-'}
        </ResourceProperty>
        {itinerary.get('fundicionEntryAllowance') && (
          <ResourceProperty label="Ingreso a Lima Fundición:">
            <Checkbox
              checked={itinerary.get('fundicionEntryAllowance') || false}
            />
          </ResourceProperty>
        )}
        <ResourceProperty label="Tipo:">
          {ITINERARY_TYPE[type.toLowerCase()].label}
        </ResourceProperty>
        {companyResource}
      </>
    );

    if (isForMine && companyItineraryAditionalFields != null) {
      basicInformationResource = (
        <>
          <h3>Información Básica</h3>
          <ResourceProperty label="Nombre:">
            {itinerary.get('itinerarySchedule').name || '-'}
          </ResourceProperty>
          <ResourceProperty label="Régimen:">
            {companyItineraryAditionalFields.shift || '-'}
          </ResourceProperty>
          <ResourceProperty label="Ruta:">
            <LinkToModuleResource text={`${route.id} - ${route.name}`} />
          </ResourceProperty>
          <ResourceProperty label="Tipo:">
            {companyItineraryAditionalFields.staffType
              ? COMPANY_STAFF_TYPE[companyItineraryAditionalFields.staffType]
                  .label
              : '-'}
          </ResourceProperty>
          <ResourceProperty label="Estado:">
            <IsActive value={active} />
          </ResourceProperty>
          <ResourceProperty label="Última verificación masiva:">
            {companyItineraryAditionalFields.lastMassVerificationDate
              ? tzNormalizeDate({
                  date: companyItineraryAditionalFields.lastMassVerificationDate,
                  format: DATE_TIME_FORMAT,
                })
              : '-'}
          </ResourceProperty>
        </>
      );
    }

    let timetableTemplate = (
      <Alert message={ITINERARY_SCHEDULE_WITHOUT_SEGMENT_LIST_MESSAGE} />
    );

    if (
      itinerary.get('itinerarySchedule').itineraryScheduleSegmentList.length
    ) {
      timetableTemplate = (
        <TimetableTemplate
          itineraryScheduleSegmentList={
            itinerary.get('itinerarySchedule').itineraryScheduleSegmentList
          }
          estimatedDepartureTime={departureTime}
          itineraryRealTimeList={geofenceAlerts}
        />
      );
    }

    const personnelList = personnel.toJS();

    const personnelTable = personnelLoading ? (
      <Loader />
    ) : (
      <Table
        columns={generatePersonnelColumns(verifyCustomer)}
        data={personnelList}
        defaultPageSize={
          personnelList.length <= 10 ? personnelList.length : DEFAULT_PAGE_SIZE
        }
        showPagination={personnelList.length > 10}
        manual={false}
        modelPath={CUSTOMER_PATH}
        filterable
        openPathInNewTab
        navigateToModelOnRowClick
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
    );

    const sketchResource = isForMine ? (
      <>
        <h3>Croquis</h3>
        <Container fluid>
          <Row>
            <Col md={6} sm={12} xs={12}>
              {renderSeatMap('', sourceItinerary, loadingSourceItinerary)}
            </Col>
            <Col md={6} sm={12} xs={12}>
              {renderPassengerTable(
                '',
                passengerListSourceItinerary,
                loadingSourceItinerary,
              )}
            </Col>
          </Row>
        </Container>
      </>
    ) : null;

    const personnelResource =
      isForMine && !personnel.isEmpty() ? (
        <>
          <h3>Personal</h3>
          <div className="mb-3">{personnelTable}</div>
        </>
      ) : null;

    const timetableResource = (
      <>
        <h3>Horarios</h3>
        <div className="mb-3">{timetableTemplate}</div>
      </>
    );

    let passengerFlowTable = (
      <Alert
        type="warning"
        message={ITINERARY_WITHOUT_PASSENGER_FLOW_MESSAGE}
      />
    );

    if (!passengerFlow.isEmpty()) {
      const passengerFlowData = passengerFlow.get(
        'passengerFlowForLocationList',
      );

      passengerFlowTable = (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Parada Autorizada',
                accessor: 'locationName',
                className: 'text-center',
              },
              {
                Header: 'Embarques',
                accessor: 'boardingPassengers',
                className: 'text-center',
                Cell: (row) =>
                  renderPassengersFlow('boarding', row.original, row.index),
              },
              {
                Header: 'Desembarques',
                accessor: 'leavingPassengers',
                className: 'text-center',
                Cell: (row) =>
                  renderPassengersFlow('leaving', row.original, row.index),
              },
            ]}
            data={passengerFlowData}
            defaultPageSize={passengerFlowData.length}
            showPagination={false}
          />
        </div>
      );
    }

    const passengerFlowResource = (
      <>
        <h3>Flujo de Pasajeros</h3>
        {passengerFlowTable}
        <CollapsibleHeader
          headerText="Boletos"
          component={ItineraryTicketTable}
          itineraryId={itineraryId}
        />
      </>
    );

    let scheduledItineraryMessage = (
      <div className="mt-3">
        <Alert type="warning" message={PENDING_SCHEDULING_WARNING_MESSAGE} />
      </div>
    );

    let scheduledItineraryResources = null;

    let historyItineraryResource = null;

    let historyItineraryFloorVariationResource = null;

    let changeTripObservationResource = null;

    let idlingConsumptionResource = null;

    let scheduled = false;

    if (trip && trip.id) {
      scheduled = true;

      const {
        assignedRegisteredBus,
        tripStatusName,
        tripCircuitStatus,
        driverAssignmentList,
        cabinCrewAssignmentList,
        estimatedDepartureTime,
        estimatedArrivalTime,
        actualArrivalTime,
        actualDepartureTime,
        initialOdometerReading,
        finalOdometerReading,
      } = trip;

      const busResource = (
        <>
          <h3>Bus</h3>
          <ResourceProperty label="Número:">
            {assignedRegisteredBus ? assignedRegisteredBus.companyBusId : '-'}
          </ResourceProperty>
          <ResourceProperty label="Mapa de Asientos:">
            {assignedRegisteredBus ? assignedRegisteredBus.seatMapName : '-'}
          </ResourceProperty>
          <ResourceProperty label="Matrícula:">
            {assignedRegisteredBus ? assignedRegisteredBus.licensePlate : '-'}
          </ResourceProperty>
          <ResourceProperty label="Estado:">{tripStatusName}</ResourceProperty>
        </>
      );

      const circuitResource = (
        <>
          <h3>Circuito</h3>
          <ResourceProperty label="Orden dentro del Circuito:">
            {tripCircuitStatus
              ? TRIP_CIRCUIT_STATUS[tripCircuitStatus].label
              : '-'}
          </ResourceProperty>
        </>
      );

      const driverData = driverAssignmentList;

      let driverResource = (
        <>
          <Alert message={ITINERARY_WITHOUT_DRIVER_INFO_MESSAGE} />
        </>
      );

      if (driverData.length > 0) {
        driverResource = (
          <div className="mb-3">
            <Table
              columns={[
                {
                  Header: 'Nombre',
                  accessor: 'driver.customer.fullName',
                  className: 'text-center',
                },
                {
                  Header: 'DNI',
                  accessor: 'driver.customer.idDocumentNumber',
                  className: 'text-center',
                },
              ]}
              data={driverData}
              defaultPageSize={driverData.length}
              showPagination={false}
            />
          </div>
        );
      }

      const cabinCrewData = cabinCrewAssignmentList;

      let cabinCrewResource = (
        <>
          <Alert
            type="warning"
            message={ITINERARY_WITHOUT_CABIN_CREW_INFO_MESSAGE}
          />
        </>
      );

      if (cabinCrewData.length > 0) {
        cabinCrewResource = (
          <div className="mb-3">
            <Table
              columns={[
                {
                  Header: 'Nombre',
                  accessor: 'cabinCrew.customer.fullName',
                  className: 'text-center',
                },
                {
                  Header: 'DNI',
                  accessor: 'cabinCrew.customer.idDocumentNumber',
                  className: 'text-center',
                },
              ]}
              data={cabinCrewData}
              defaultPageSize={cabinCrewData.length}
              showPagination={false}
            />
          </div>
        );
      }

      const stadisticResource = (
        <>
          <h3>Estadísticas</h3>
          <ResourceProperty label="Hora de Salida Estimada:">
            {estimatedDepartureTime
              ? tzNormalizeDate({
                  date: estimatedDepartureTime,
                  format: FULL_DATE_TIME_FORMAT,
                })
              : '-'}
          </ResourceProperty>
          <ResourceProperty label="Hora de Salida Actual:">
            {actualDepartureTime
              ? tzNormalizeDate({
                  date: actualDepartureTime,
                  format: FULL_DATE_TIME_FORMAT,
                })
              : '-'}
          </ResourceProperty>
          <ResourceProperty label="Hora de Llegada Estimada:">
            {estimatedArrivalTime
              ? tzNormalizeDate({
                  date: estimatedArrivalTime,
                  format: FULL_DATE_TIME_FORMAT,
                })
              : '-'}
          </ResourceProperty>
          <ResourceProperty label="Hora de Llegada Actual:">
            {actualArrivalTime
              ? tzNormalizeDate({
                  date: actualArrivalTime,
                  format: FULL_DATE_TIME_FORMAT,
                })
              : '-'}
          </ResourceProperty>
          <ResourceProperty label="Lectura de Odómetro Inicial:">
            {initialOdometerReading || '-'}
          </ResourceProperty>
          <ResourceProperty label="Lectura de Odómetro Final:">
            {finalOdometerReading || '-'}
          </ResourceProperty>
        </>
      );

      scheduledItineraryMessage = null;

      scheduledItineraryResources = (
        <>
          {busResource}
          {circuitResource}
          {!isForMine ? (
            <>
              <h3>Conductores</h3>

              {driverResource}
            </>
          ) : null}
          {!isForMine ? (
            <>
              <h3>Servicio a Bordo</h3>
              {cabinCrewResource}
            </>
          ) : null}
          {!isForMine ? stadisticResource : null}
        </>
      );
    }

    historyItineraryResource = (
      <>
        {!isForMine ? (
          <>
            <hr />
            <CollapsibleHeader
              headerText="Historial de buses y conductores"
              component={() => renderHistory(trip && trip.id)}
              headerFont="h3"
            />
          </>
        ) : null}
      </>
    );

    historyItineraryFloorVariationResource = (
      <>
        {!isForMine ? (
          <>
            <hr />
            <CollapsibleHeader
              headerText="Historial de variación de pisos"
              component={renderFloorVariationHistory}
              headerFont="h3"
            />
          </>
        ) : null}
      </>
    );

    changeTripObservationResource = (
      <>
        {!isForMine &&
        itinerary.get('changeTripReasonList', []).length !== 0 ? (
          <>
            <hr />
            <CollapsibleHeader
              headerText="Observaciones de Cambio de Programación"
              component={renderChangeTripObservation}
              headerFont="h3"
            />
          </>
        ) : null}
      </>
    );
    const idlingConsumptionObservations =
      itinerary.get('idlingConsumptionObservations') || [];

    const renderIdlingConsumptionObservations = () => (
      <>
        {idlingConsumptionObservations.map((idlingConsumptionObservation) => (
          <div key={idlingConsumptionObservation.id}>
            <Row>
              <Col>
                <h4>Observación de Consumo Relentí</h4>

                <ResourceProperty label="Motivo:">
                  {(idlingConsumptionObservation.idlingConsumptionMotive &&
                    idlingConsumptionObservation.idlingConsumptionMotive
                      .description) ||
                    '-'}
                </ResourceProperty>

                <ResourceProperty label="Minutos de Relentí:">
                  {idlingConsumptionObservation.idlingConsumptionTime || '-'}
                </ResourceProperty>

                <ResourceProperty label="Galones de Relentí:">
                  {idlingConsumptionObservation.idlingConsumptionNumberOfGallon ||
                    '-'}
                </ResourceProperty>

                <ResourceProperty label="Minutos Reales de Relentí:">
                  {idlingConsumptionObservation.realIdlingConsumptionTime ||
                    '-'}
                </ResourceProperty>

                <ResourceProperty label="Galones Reales de Relentí:">
                  {idlingConsumptionObservation.realIdlingConsumptionNumberOfGallon ||
                    '-'}
                </ResourceProperty>
              </Col>

              <Col>
                <h4>Observación</h4>
                <p>{idlingConsumptionObservation.observation || '-'}</p>
              </Col>
            </Row>
          </div>
        ))}
      </>
    );

    idlingConsumptionResource = (
      <>
        {!isForMine && idlingConsumptionObservations.length > 0 ? (
          <>
            <hr />
            <CollapsibleHeader
              headerText="Observaciones de Consumo Relentí"
              component={renderIdlingConsumptionObservations}
              headerFont="h3"
            />
          </>
        ) : null}
      </>
    );

    const itineraryHistoryAlertResource = (
      <>
        <hr />
        <CollapsibleHeader
          headerText="Historial de alertas"
          component={ItineraryHistoryAlerts}
          itineraryId={id}
        />
      </>
    );

    const itineraryGeofenceAlertResource = (
      <>
        <hr />
        <CollapsibleHeader
          headerText="Alertas de Geocercas"
          component={ItineraryGeofenceAlerts}
          itineraryId={id}
        />
      </>
    );

    content = (
      <>
        {createdFromApiMessageAlert}
        {templateAlert}
        {scheduledItineraryMessage}
        {basicInformationResource}
        {timetableResource}
        {passengerFlowResource}
        {scheduledItineraryResources}
        {!isForMine && renderItineraryClosure()}
        {historyItineraryResource}
        {historyItineraryFloorVariationResource}
        {itineraryGeofenceAlertResource}
        {itineraryHistoryAlertResource}
        {changeTripObservationResource}
        {idlingConsumptionResource}
        {sketchResource}
        {personnelResource}
        <Modal
          show={showModal}
          title={modalTitle}
          body={modalBody}
          onClickClose={() => setShowModal(false)}
        />
      </>
    );

    toolbar = (
      <ItineraryToolbar
        itineraryId={id}
        drivers={drivers}
        scheduled={scheduled}
        type={type}
        itinerary={itinerary}
        isForMine={isForMine > 0}
        idlingConsumptionObservation={itinerary.get(
          'idlingConsumptionObservation',
        )}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Itinerario"
      content={content}
    />
  );
};

const mapStateToProps = ({ ItineraryUnit, authentication }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    { text: 'Itinerarios', href: ITINERARY_PATH },
    { text: 'Ver', href: '' },
  ],
  itinerary: ItineraryUnit.Itinerary.getIn(['current', 'content']),
  loading: !ItineraryUnit.Itinerary.getIn(['current', 'activity']).isEmpty(),
  personnelLoading: !ItineraryUnit.Itinerary.getIn([
    'current',
    'personnelActivity',
  ]).isEmpty(),
  passengerListSourceItinerary: ItineraryUnit.ServiceMerge.getIn([
    'sourceItinerary',
    'passengerList',
  ]),
  passengerFlow: ItineraryUnit.Itinerary.getIn(['current', 'passengerFlow']),
  personnel: ItineraryUnit.Itinerary.getIn(['current', 'personnel']),
  history: ItineraryUnit.Itinerary.getIn(['current', 'history']),
  drivers: ItineraryUnit.Itinerary.getIn(['current', 'drivers']),
  isForMine: !!authentication.get('user').salesSessionUserId,
  sourceItinerary: ItineraryUnit.ServiceMerge.getIn([
    'sourceItinerary',
    'seatMap',
  ]),
  loadingSourceItinerary: ItineraryUnit.ServiceMerge.getIn([
    'sourceItinerary',
    'loading',
  ]),
  geofenceAlerts: ItineraryUnit.Itinerary.getIn([
    'current',
    'geofenceAlerts',
  ]).toJS(),
  itineraryClosure: ItineraryUnit.ItineraryClosure.getIn([
    'current',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchGetItinerary: getItineraryV2,
  dispatchClearItinerary: clearItinerary,
  dispatchGetItinerarySchedule: getItinerarySchedule,
  dispatchGetPassengerFlowForItinerary: getPassengerFlowForItinerary,
  dispatchClearPassengerFlowForItinerary: clearPassengerFlowForItinerary,
  dispatchGetListDriversForItinerary: getListDriversForItinerary,
  dispatchClearDrivers: clearDrivers,
  dispatchPutBoardPassenger: putBoardPassenger,
  dispatchClearPersonnelForItinerary: clearPersonnelForItinerary,
  dispatchGetPersonnelForItinerary: getPersonnelForItinerary,
  dispatchGetItineraryHistory: getItineraryHistory,
  dispatchClearItineraryHistory: clearItineraryHistory,
  dispatchPostVerifyCustomer: postVerifyCustomer,
  dispatchClearItinerarySeatMap: clearItinerarySeatMap,
  dispatchGetItinerarySeatMap: getItinerarySeatMap,
  dispatchGetItineraryGeofenceAlerts: getItineraryGeofenceAlerts,
  dispatchClearItineraryGeofenceAlerts: clearItineraryGeofenceAlerts,
  dispatchGetItineraryClosure: getItineraryClosure,
  dispatchClearItineraryClosure: clearItineraryClosure,
};

Itinerary.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  match: matchPropTypes.isRequired,
  itinerary: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool.isRequired,
  personnelLoading: PropTypes.bool.isRequired,
  dispatchGetItinerary: PropTypes.func.isRequired,
  dispatchClearItinerary: PropTypes.func.isRequired,
  passengerFlow: PropTypes.instanceOf(Immutable.Map).isRequired,
  personnel: PropTypes.instanceOf(Immutable.Set).isRequired,
  dispatchGetPassengerFlowForItinerary: PropTypes.func.isRequired,
  dispatchClearPassengerFlowForItinerary: PropTypes.func.isRequired,
  dispatchGetListDriversForItinerary: PropTypes.func.isRequired,
  dispatchPutBoardPassenger: PropTypes.func.isRequired,
  dispatchClearDrivers: PropTypes.func.isRequired,
  dispatchClearPersonnelForItinerary: PropTypes.func.isRequired,
  dispatchGetPersonnelForItinerary: PropTypes.func.isRequired,
  dispatchPostVerifyCustomer: PropTypes.func.isRequired,
  dispatchClearItinerarySeatMap: PropTypes.func.isRequired,
  loadingSourceItinerary: PropTypes.bool.isRequired,
  sourceItinerary: PropTypes.instanceOf(Immutable.Map),
  dispatchGetItinerarySeatMap: PropTypes.func.isRequired,
  drivers: PropTypes.instanceOf(Immutable.Set).isRequired,
  history: PropTypes.instanceOf(Immutable.Map).isRequired,
  isForMine: PropTypes.bool.isRequired,
  dispatchGetItineraryHistory: PropTypes.func.isRequired,
  dispatchClearItineraryHistory: PropTypes.func.isRequired,
  passengerListSourceItinerary: PropTypes.instanceOf(Immutable.Set).isRequired,
  geofenceAlerts: PropTypes.arrayOf(Immutable.List).isRequired,
  itineraryClosure: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchGetItineraryGeofenceAlerts: PropTypes.func.isRequired,
  dispatchClearItineraryGeofenceAlerts: PropTypes.func.isRequired,
  dispatchGetItineraryClosure: PropTypes.func.isRequired,
  dispatchClearItineraryClosure: PropTypes.func.isRequired,
};

Itinerary.defaultProps = {
  sourceItinerary: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(Itinerary);
